export default __webpack_public_path__ + "static/media/starter_screen_icon.17bf018c.svg";